import React from 'react';
import Select from 'react-select'; // import du composant "react-select"

function Dropdown({ref, options, onChange, value, placeholder, className, isMulti=false}) {

  const handleChange = (selectedOption) => {
    console.log("Dropdown selected option:", selectedOption);
    onChange(selectedOption);
  };

  return (
    <div>
        <Select 
          ref={ref}
          options={options} 
          onChange={onChange} 
          value={value}
          placeholder={placeholder}
          className={className}
          isMulti={isMulti} // ajout de la propriété isMulti
        />
    </div>
  );
}

export default Dropdown;
